import React, { useEffect, useState } from "react";

const PromotionselectDropdown = ({ formData, setFormData }) => {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchPromotionData = async () => {
      try {
        const response = await fetch(`${baseUrl}/promotion/get-promotions`);
        if (response.status === 200) {
          const data = await response.json();
          // console.log("Fetched promotion data: select", data.result);
          setData(data.result);
        } else {
          throw new Error("Unable to fetch data");
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchPromotionData();
  }, []);

  const filteredOptions = data.filter((test) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = new Date(test.startDate);
    const endDate = new Date(test.endDate);

    const isActive = test.status === "active";

    const isWithinDateRange = today >= startDate && today <= endDate;

    return (
      isActive &&
      isWithinDateRange &&
      test.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const handleSelect = (test) => {
    setFormData((prev) => {
      const currentRequiredTests = Array.isArray(prev.requiredTests)
        ? prev.requiredTests
        : [];

      const exists = currentRequiredTests.find((t) => t.title === test.title);
      if (exists) {
        return {
          ...prev,
          requiredTests: currentRequiredTests.filter(
            (t) => t.title !== test.title
          ),
        };
      } else {
        return {
          ...prev,
          requiredTests: [...currentRequiredTests, { ...test, fasting: false }],
        };
      }
    });
  };

  const isSelected = (test) => {
    const currentRequiredTests = Array.isArray(formData.requiredTests)
      ? formData.requiredTests
      : [];
    return currentRequiredTests.some((t) => t.title === test.title);
  };

  return (
    <>
      {/* Main Button to trigger the popup */}
      <button
        type="button"
        className="w-full h-[41px] border-[#4ab0b0] border-[1px] rounded-[6px]"
        onClick={() => setIsDropdownOpen(true)}
      >
        {formData.requiredTests?.length > 0
          ? `${formData.requiredTests.length} Tests Selected`
          : "Pick the Required Promotions"}
      </button>

      {isDropdownOpen && (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-[#11485B] md:w-[50%] w-[90%] h-[50%] p-4 rounded-lg shadow-lg relative">
            <button
              type="button"
              className="absolute top-0 right-2 text-4xl text-gray-500"
              onClick={() => setIsDropdownOpen(false)}
            >
              &times;
            </button>

            <div className="p-4">
              <input
                className="w-full py-2 px-4 border rounded-lg"
                type="text"
                placeholder="Search Tests"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="px-2 h-[70%] overflow-y-auto">
              {filteredOptions.map((test) => (
                <div
                  key={test.title} // You can still use `test.title` as a unique key
                  className="flex items-center p-2 hover:bg-gray-100 hover:text-black"
                >
                  <div className="flex items-center justify-center w-10">
                    <input
                      type="checkbox"
                      checked={isSelected(test)} // Check if the test is selected using `test.title`
                      onChange={() => handleSelect(test)} // Pass the entire test object to handleSelect
                    />
                  </div>
                  <label
                    className="cursor-pointer"
                    onClick={() => handleSelect(test)} // Same function for label click
                  >
                    {test.title}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PromotionselectDropdown;
